module.exports = __webpack_public_path__ + "static/6-856cb8b71e537089cb1ea7dd7ad2d305.jpg";